import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import TeamMemberPaneHeader from '../TeamMemberPaneHeader'
import { TEAM_MEMBER_PANE_TAB } from '../../../state/constants/index'
import TeamMemberCreateForm from '../../../containers/team-members/TeamMemberCreateForm'
import TeamMemberPermissionEditForm from '../../../containers/team-members/TeamMemberPermissionEditForm'
import EntityHeaderTitle from 'src/components/ui/entity/EntityHeaderTitle'
import UIMessages from 'src/utils/ui-messages'

interface ITeamMemberEditPaneProps {
  id: string
}

interface ITeamMemberEditPaneState {
  tab: string
}

class TeamMemberEditPane extends React.Component<
  RouteComponentProps<ITeamMemberEditPaneProps>,
  ITeamMemberEditPaneState
> {
  constructor(props: RouteComponentProps<ITeamMemberEditPaneProps>) {
    super(props)
    this.state = {
      tab: TEAM_MEMBER_PANE_TAB.PERSONAL_INFO
    }
  }

  public render() {
    const { tab } = this.state
    const teamMemberId = this.props.match.params.id

    return (
      <React.Fragment>
        {teamMemberId && (
          <div className='p2'>
            <EntityHeaderTitle>{UIMessages.teamMember.editTeamMember}</EntityHeaderTitle>
          </div>
        )}
        <TeamMemberPaneHeader
          currentTab={tab}
          changeTab={t => {
            this.setState({ tab: t })
          }}
        />
        {tab === TEAM_MEMBER_PANE_TAB.PERSONAL_INFO && <TeamMemberCreateForm {...this.props} />}
        {tab === TEAM_MEMBER_PANE_TAB.PERMISSION && (
          <TeamMemberPermissionEditForm id={teamMemberId} handleRedirect={this.handleRedirect} />
        )}
      </React.Fragment>
    )
  }

  private handleRedirect = () => {
    this.props.history.goBack()
  }
}

export default TeamMemberEditPane



// WEBPACK FOOTER //
// ./src/components/team-members/form/TeamMemberEditPane.tsx